<template>
  <div>
    <div>
      <vs-popup
        :title="
          editMode
            ? 'ویرایش ' + $t('BaseSalePrice')
            : 'درج ' + $t('BaseSalePrice')
        "
        :active.sync="showModal"
      >
        <form>
          <div class="vx-col w-full">
            <div class="vx-col w-full my-2">
              <label class="vs-select--label my-1">{{
                $t("WarehouseName")
              }}</label>

              <v-select
                label="name"
                name="warehouse"
                :options="allWarehouses"
                v-model="model.storeId"
                v-validate="{ required: true }"
                :reduce="(x) => x.id"
                ref="warehouseSelect"
                :clearable="true"
                dir="rtl"
              >
              </v-select>
            </div>
          </div>

          <div class="vx-col w-full mt-4">
            <vs-button
              type="filled"
              class="float-right mb-4"
              @click.prevent="submitForm"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </form>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { mapActions ,mapGetters } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

export default {
  name: "saleManagement_Contract_Management_BaseSalePricePopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      editMode: false,
      disabled: false,
      inventoryModel:{}
    };
  },
  computed: {
    ...mapGetters({
      allWarehouses: "warehouse/list",
    }),
    showModal: {
      get: function () {
        this.fetchWarehouses();
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      assignContractStore: "sale/assignContractStore",
      fetchWarehouses: "warehouse/fetchListWithNOTakeSkip",

    }),
    submitForm() {

            this.assignContractStore(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                setTimeout(() => {
                  this.$emit("finish");
                  this.disabled = false;
                }, 0);
              });
            });
         
    },
  },
  watch: {
    show() {
      if (this.show) {
        if (this.model.id) {
          // edit mode
          this.editMode = true;
        } else {
          this.editMode = false;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.con-vs-popup .vs-popup{
  width: 1300px !important;
  min-height: 500px !important;
}
.vs-popup--content{
  min-height: 500px !important;

}</style>
